import React from 'react';
import HeroContent from "../components/HeroContent";
import AboutMe from "../components/AboutMe";
import Skills from "../components/Skills";
import Projects from "../components/Projects";
import Footer from "../components/Footer";
import Contacts from "../components/Contacts";

function Homepage() {
    return (
        <>
            <HeroContent />
            <Contacts />
            <AboutMe />
            <Skills />
            <Projects />
            <Footer />
        </>
    );
}

export default Homepage;